/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CommentReactionNotificationActionData } from './CommentReactionNotificationActionData';
import {
    CommentReactionNotificationActionDataFromJSON,
    CommentReactionNotificationActionDataFromJSONTyped,
    CommentReactionNotificationActionDataToJSON,
} from './CommentReactionNotificationActionData';

/**
 * 
 * @export
 * @interface CommentReactionNotificationAction
 */
export interface CommentReactionNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof CommentReactionNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof CommentReactionNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof CommentReactionNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {CommentReactionNotificationActionData}
     * @memberof CommentReactionNotificationAction
     */
    data: CommentReactionNotificationActionData;
}

/**
 * Check if a given object implements the CommentReactionNotificationAction interface.
 */
export function instanceOfCommentReactionNotificationAction(value: object): value is CommentReactionNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function CommentReactionNotificationActionFromJSON(json: any): CommentReactionNotificationAction {
    return CommentReactionNotificationActionFromJSONTyped(json, false);
}

export function CommentReactionNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentReactionNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': CommentReactionNotificationActionDataFromJSON(json['data']),
    };
}

export function CommentReactionNotificationActionToJSON(value?: CommentReactionNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': CommentReactionNotificationActionDataToJSON(value.data),
    };
}

